<template>
  <div class="di">
    <div class="di-head">
      <img
        v-if="iconUrl"
        :src="iconUrl"
        class="di-icon"
        :alt="typeName"
      >
      <div>
        <div class="di-name">
          {{ device.label }}
          <span
            v-if="device.is_primary"
            class="di-badge"
          >{{ $t('Main') }}</span>
        </div>
        <div class="di-type">
          {{ typeName }}
        </div>
      </div>
    </div>

    <ul class="di-list">
      <li v-if="device.imei">
        <span>{{ $t('IMEI') }}</span><strong>{{ device.imei }}</strong>
      </li>
      <li v-if="device.serial_number">
        <span>{{ $t('Serial number') }}</span><strong>{{ device.serial_number }}</strong>
      </li>
      <li v-if="position">
        <span>{{ $t('Speed') }}</span><strong>{{ position.speed || 0 }} Km/h</strong>
      </li>
      <li v-if="position && position.device_battery_level">
        <span>{{ $t('Battery level') }}</span><strong>{{ position.device_battery_level }}</strong>
      </li>
      <li v-if="position">
        <span>{{ $t('Sent date') }}</span><strong>{{ formatDate(position.last_tracking_at) }}</strong>
      </li>
      <li v-if="position">
        <span>{{ $t('Position') }}</span><strong>{{ position.lat }}, {{ position.long }}</strong>
      </li>
    </ul>

    <div class="di-actions">
      <button
        type="button"
        class="di-action"
        @click="abrirDispositivo"
      >
        <i class="fa fa-external-link-alt" /> {{ $t('See device') }}
      </button>
    </div>

    <div class="di-vehicle">
      <template v-if="device.vehicle">
        <div class="di-vehicle-name">
          {{ device.vehicle.name }}
          <span
            v-if="device.vehicle.license_plate"
            class="di-plate"
          >{{ device.vehicle.license_plate }}</span>
        </div>
        <button
          type="button"
          class="di-action"
          @click="$emit('open-vehicle-devices', device.vehicle.id)"
        >
          <i class="fa fa-microchip" /> {{ $t('See vehicle devices') }}
        </button>
      </template>
      <div
        v-else
        class="di-unlinked"
      >
        <i class="fa fa-unlink" /> {{ $t('Not linked to any vehicle') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceInfo',

  props: {
    device: {
      type: Object,
      required: true,
    },
  },

  computed: {
    position() {
      return this.device.position || null
    },

    typeName() {
      return (this.device.device_type && this.device.device_type.name) || this.$t('Uncategorized')
    },

    iconUrl() {
      return (this.device.device_type && this.device.device_type.file) || null
    },
  },

  methods: {
    abrirDispositivo() {
      this.$router.push(`/devices/view/${this.device.id}`)
    },

    formatDate(valor) {
      if (!valor) {
        return '-'
      }

      return new Date(String(valor).replace(' ', 'T')).toLocaleString('pt-BR')
    },
  },
}
</script>

<style scoped>
.di-head {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #ebe9f1;
}

.di-icon {
  width: 34px;
  height: 34px;
  object-fit: contain;
}

.di-name {
  font-weight: 600;
  color: #5e5873;
}

.di-type {
  font-size: 0.8rem;
  color: #6e6b7b;
}

.di-badge {
  background: #7367f0;
  color: #fff;
  border-radius: 4px;
  padding: 1px 6px;
  font-size: 0.65rem;
  margin-left: 4px;
  vertical-align: middle;
}

.di-list {
  list-style: none;
  padding: 0.75rem 0;
  margin: 0;
}

.di-list li {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.3rem 0;
  font-size: 0.85rem;
  color: #6e6b7b;
}

.di-list strong {
  color: #5e5873;
}

.di-actions {
  padding-bottom: 0.75rem;
}

.di-vehicle {
  border-top: 1px solid #ebe9f1;
  padding-top: 0.75rem;
}

.di-vehicle-name {
  font-weight: 600;
  color: #5e5873;
  margin-bottom: 0.5rem;
}

.di-plate {
  background: #f1f5f9;
  color: #334155;
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 0.75rem;
  margin-left: 6px;
}

.di-action {
  border: 1px solid #7367f0;
  background: #fff;
  color: #7367f0;
  border-radius: 6px;
  padding: 5px 12px;
  font-size: 0.8rem;
}

.di-action:hover {
  background: #f3f2ff;
}

.di-unlinked {
  font-size: 0.85rem;
  color: #ea5455;
}
</style>
